import React from "react";
import banner from "./images/1_home/banner_home.jpg";
import homePhones from "./images/1_home/HOME_phones.png";
import iconoApple from "./images/1_home/apple.png";
import iconoGoogle from "./images/1_home/google-play-badge.png";
import { TITLE_FONT_SIZE, TEXT_FONT_SIZE } from "./const.js";

const Home = () => {
  return (
    <div
      style={{
        display: "flex",
        background: `url(${banner}) no-repeat center center fixed`,
        height: "108vmin",
        flexDirection: "row",
        justifyItems: "center",
        alignItems: "center",
        backgroundSize: "100% 100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          color: "white",
          paddingLeft: 10,
          alignItems: "flex-end",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            fontFamily: "OswaldBoldItalic",
            flex: 1,
            textAlign: "right",
            marginBottom: 10,
            fontSize: TITLE_FONT_SIZE,
          }}
        >
          THE OFFICIAL STORM BOWLING APP IS HERE
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            textAlign: "right",
            marginBottom: 30,
            maxWidth: "70%",
            fontSize: TEXT_FONT_SIZE,
          }}
        >
          Welcome to the ALL-NEW Storm Bowling app! This app is designed for
          bowlers of all averages and skill levels. You will be able to find an
          assortment of tools to improve your game and start to see the lanes
          like the professional do.
        </div>
        <div
          style={{
            display: "flex",
            fontFamily: "OswaldBoldItalic",
            flex: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              fontFamily: "OswaldBoldItalic",
              flex: 1,
              alignItems: "center",
              justifyContent: "flex-end",
              marginRight: -15,
            }}
          >
            <a
              href={"https://apps.apple.com/us/app/storm-bowling/id1494132195"}
            >
              <img style={{ width: "95%" }} src={iconoApple} alt={"apple"} />
            </a>
            <a
              href={
                "https://play.google.com/store/apps/details?id=ca.helmac.stormbowling"
              }
            >
              <img style={{ width: "95%" }} src={iconoGoogle} alt={"google"} />
            </a>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", flex: 1 }}>
        <div
          style={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img style={{ width: "40%" }} src={homePhones} alt={"phones"} />
        </div>
      </div>
    </div>
  );
};

export default Home;
